<template>
  <section class="page-container">
    <h1 v-if="!isDialog">Customers</h1>
    <div
      v-if="!isDialog"
      class="btn-top-container">
      <v-button
        class="create-account"
        size="mini"
        @click="handleCreateAccount"
      >Create Account
      </v-button>
    </div>

    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="ID, Name, Registered Login, Contact, Phone, Email, Referral Code, ID No."
        :prefixIcon="'el-icon-search'"
        @keyEnter="filterData"
      />
    </div>

    <div
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>
              Partner
              <span
                v-if="partner_id.length"
                class="all"
                @click="handlerNoneAll('partner_id')">None</span>
            </span>
            <span>
              <v-select
                v-model="partner_id"
                placeholder="All"
                multiple
                :list="partnerList"
                @change="filterData" />
            </span>
          </div>
          <div class="form-item">
            <span>
              Referrer
            </span>
            <span>
              <v-input
                v-model="referrer_code"
                @change="filterData" />
            </span>
          </div>
        </div>

        <div
          class="filter-right left-border"
        >
          <div class="form-item">
            <span>
              Type
              <span
                class="all"
                @click="handlerFilter('type','userTypeOptions')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('type')">None</span>
            </span>
            <v-checkbox-group
              v-model="type"
              :list="userTypeOptions"
              @change="filterData"
            />
          </div>
          <div class="form-item status-button">
            <span>
              Status
              <span
                class="all"
                @click="handlerFilter('status','statusOption')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>
            </span>
            <v-checkbox-group
              v-model="status"
              :list="statusOption"
              @change="filterData">
              <!--              <template #default="{ item }">-->
              <!--                <span class="flex">-->
              <!--                  <span-->
              <!--                    class="circle"-->
              <!--                    :class="{-->
              <!--                      'red': item.id == 0,-->
              <!--                      'orange-light': item.id == 1,-->
              <!--                      'yellow-dark': item.id == 2,-->
              <!--                      'blue': item.id == 3,-->
              <!--                      'green': item.id == 4-->
              <!--                    }"></span>-->
              <!--                  <span>{{ item['name'] }}</span>-->
              <!--                </span>-->
              <!--              </template>-->
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Channel
              <span
                class="all"
                @click="handlerFilter('source','channelList')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('source')">None</span>
            </span>
            <span>
              <v-checkbox-group
                v-model="source"
                :list="channelList"
                :isColumn="false"
                @change="filterData"
              />
            </span>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item status-verify">
            <span>
              Verified
              <span
                class="all"
                @click="handlerFilter('verify_type','verifyOptions')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('verify_type')">None</span>            </span>
            <v-checkbox-group
              v-model="verify_type"
              :list="verifyOptions"
              :isColumn="false"
              @change="filterData">
              <!--              <template #default="{ item }">-->
              <!--                <span class="flex">-->
              <!--                  <span-->
              <!--                    class="span-options"-->
              <!--                    :class="{-->
              <!--                      'gray': item.id == 1,-->
              <!--                      'green': item.id == 2,-->
              <!--                      'red': item.id == -2-->
              <!--                    }">{{ item['name'] }}</span>-->
              <!--                </span>-->
              <!--              </template>-->
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Tags
              <span
                class="all"
                @click="handlerFilter('tags',)">All</span>
              <span
                class="all"
                @click="handlerNoneAll('tags')">None</span>            </span>
            <div>
              <v-checkbox
                v-model="uploadRequestStts"
                :isBoolean="false"
                class="upload-status"
                @change="filterData"
              >Unread Upload</v-checkbox>
              <v-checkbox
                v-model="tier_base"
                :isBoolean="false"
                class="diamond-status"
                @change="filterData"
              >Professional</v-checkbox>
              <v-checkbox
                v-model="is_flagged"
                :isBoolean="false"
                class="upload-status"
                @change="filterData"
              >Flagged</v-checkbox>
              <v-checkbox
                v-model="is_blocked"
                :isBoolean="false"
                class="blocked-status"
                @change="filterData"
              >Blocked</v-checkbox>
            </div>
          </div>
        </div>
        <div class="filter-last">
          <div class="form-item">
            <span>
              Consent
              <!--<span
                class="all"
                @click="handlerFilter('user_agreement_1','user_agreement_option')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('user_agreement_1')">None</span>-->
            </span>
            <v-checkbox-group
              v-model="user_agreement_1"
              :list="user_agreement_option"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': item.id ==0,
                      'verified-color': item.id == 1,
                      'gray': item.id == -1,
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Pro/Pro Plus
              <span
                class="all"
                @click="handlerFilter('vip_level','vip_level_list')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('vip_level')">None</span>
            </span>
            <v-checkbox-group
              v-model="vip_level"
              :list="vip_level_list"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="fs-12"
                  >{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        :header-row-class-name="'tableHeader'"
        style="width: 100%"
        :row-class-name="'pointer'"
        @row-click="rowClick"
      >
        <el-table-column
          v-if="isDialog"
          width="55">
          <template slot-scope="scope">
            <span :class="[scope.row.checked? 'radio-circle-checked': 'radio-circle' ]"></span>
            <!-- <span>{{ scope.row.checked }}</span> -->
            <!-- <el-radio v-model="tableRadio[scope.$index].checked"/> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          width="60"
        >
          <template #default="{row}">
            <div class="flex-center flex-align-center flex">

              <span
                v-if="row.agency_icon"
                class="flex-center mg-r-10"
              >
                <img
                  :style="{height:'22px'}"
                  :src="row.agency_icon" >
              </span>
              <font-awesome-icon
                :class="{'orange': row.is_flagged}"
                :icon="row.is_flagged? 'person-circle-exclamation' : 'user'" />
            </div>

          </template>
        </el-table-column>

        <!--        <el-table-column-->
        <!--          width="80">-->
        <!--          <template #default="{ row }">-->
        <!-- -->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          width="100">
          <template slot-scope="scope">

            <span  class="span-status type-status">{{ scope.row.identity_language }}</span>
            <p class="fs-12 text-italic">{{getOptionName('vip_level_list',scope.row.vip_level)}}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="95px"
          label="Created">
          <template #default="{ row }">
            <div class="time-text">
              <span>{{ row.created_at.split(" ")[0] }}</span>
              <span> {{ row.created_at.split(" ")[1] }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column
          prop="isrd_nm"
          :show-overflow-tooltip="true"
          label="Name">
          <template #default="{ row }">
            <div>
              <span
                v-if="row.is_top_data"
                class="green_tip block">Potential Match</span>
              <span
                v-if="row.is_green_tip"
                class="green_tip">{{row.green_tip}}</span>
              <span
                v-if="isDialog"
                class="showLick cname"
                :class="{'unname' : row.isrd_nm == ' '}"
                @click="rowClickFn(row)">
                {{ row.isrd_nm != ' '? row.isrd_nm : 'Unnamed Account'}}
              </span>
              <router-link
                v-else
                :to="rowClickFn(row)"
                class="showLick cname"
                :class="{'unname' : row.isrd_nm == ' '}">
                {{ row.isrd_nm != ' '? row.isrd_nm : 'Unnamed Account'}}
              </router-link>
              <!-- <p>{{ row.isrd_nm }}</p> -->
              <p class="liter-text">#{{ row.id }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="registered_login"
          label="Registered Login & Contact"
        >
          <template slot-scope="scope">
            <span
              class="login-text"
              :class="{'color-purple':scope.row.attached_account}">
              {{ scope.row.registered_login }}
              <email-tooltip
                v-if="scope.row.identity==2"
                :email="scope.row.registered_login"></email-tooltip>
            </span>
            <p
              v-if="scope.row.identity==2"
              class="liter-text">{{ scope.row.contact_nm }} {{ scope.row.contact_phone}} {{scope.row.contact_email}}</p>
            <p    v-if="[0,1].includes(scope.row.user_agreement_1)">
              <span class="flex flex-align-center">
                <font-awesome-icon
                  icon="square-check"
                  class="mg-r-3 fs-12"
                  :class="{'pending_verify-color':scope.row.user_agreement_1==0,'verified-color':scope.row.user_agreement_1==1} "></font-awesome-icon>
                <span
                  class="fs-12"
                  :class="{
                    'pending_verify-color': scope.row.user_agreement_1 ==0,
                    'verified-color': scope.row.user_agreement_1 == 1,
                  }">{{getOptionName('user_agreement_option',scope.row.user_agreement_1) }}</span>
              </span>
            </p>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="contact_nm"-->
        <!--          label="Contact (Company)"-->
        <!--        ></el-table-column>-->
        <!--        <el-table-column-->
        <!--          prop="contact_phone"-->
        <!--          label="Phone (Company)"-->
        <!--        ></el-table-column>-->
        <el-table-column
          prop="total_policy_num"
          label="Policies"
          width="75"
        ></el-table-column>
        <el-table-column
          label="Status & Tags"
          width="140"
        >
          <template #default="{ row }">
            <div class="flex">
              <span
                class="span-status"
                :class="{
                  'success': row.status == 1,
                  'warning': row.status == 2,
                  'error': row.status == 0
                }">{{ row.status_language }}</span>
            </div>

            <div class="flex tags">
              <!-- <span
                v-if="row.verified != 20"
                class="span-status warning-plain">Need Approval</span> -->
              <span
                v-if="row.upload_request_stts == 1"
                class="span-status unread-uplod">Unread Upload</span>
            </div>
            <div
              v-if="row.is_tier_base"
              class="flex tags">
              <span
                class="span-status diamond-status">Professional</span>
            </div>
            <div
              v-if="row.referral_coupon"
              class="flex tags">
              <span
                class="span-status code-status">Custom Coupon</span>
            </div>
            <div
              v-if="row.referral_discount"
              class="flex tags">
              <span
                class="span-status diamond-status">Custom Discount</span>
            </div>
            <div
              v-if="row.is_blocked"
              class="flex tags">
              <span
                class="span-status blocked-status">Blocked</span>
            </div>
            <div
              v-if="row.is_flagged"
              class="flex tags">
              <span class="span-status unread-uplod">Flagged</span>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          label="Verified"
          width="140">
          <template #default="{row}">
            <div class="flex">
              <span
                v-if="row.verify_language"
                class="span-status"
                :class="{
                  'verified': row.verified == 20,
                  'pending_verify ': row.verified == -1,
                  'not_verify': row.verified == -2
                }">{{ row.verify_language }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"
    />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getCustomerList} from '@/api/account'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'Accounts',
  mixins: [MixinOptions],
  props:{
    isDialog:{
      type:[Boolean,String],
      default:false
    },
    formData:{
      type:Object,
      default:()=>({})
    },
    isShare:{
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10,
      },
      type: [],
      search: '',
      tableData: [],
      status: [],
      referralRequestStts: 0,
      uploadRequestStts: 0,
      selectRow:'',
      tier_base:0,
      referral_coupon: 0,
      referral_discount: 0,
      date: [],
      verify_type: [],
      is_blocked: 0,
      is_flagged: 0,
      source:[],
      partner_id:'',
      referrer_code:'',
      user_agreement_1:[],
      vip_level:[],
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    verifyOptions(){
      let {verify_type} = this.specialOptions||{}
      return verify_type||[]
    },
    partnerList(){
      let {user_from_partners} = this.globalOptions||{}
      return user_from_partners|| []
    },

    channelList(){
      let {register_source} = this.globalOptions||{}
      return register_source||[]
    },
  },
  watch:{
    isDialog:{
      immediate:true,
      handler(val){
        if(val){
          this.network().getCustomerList()
        }
      }
    }
  },
  created() {
    if(!this.isDialog){
      let {account={}} =  this.selectFilterData||{}
      Object.keys(account).forEach(item=>{
        this[item] = account[item]
      })
      this.setFilterData(account||{})
    }
    this.network().getCustomerList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    handleCreateAccount(){
      this.$router.push({
        path:'/accounts/create',
        query:{
          user_type:1
        }
      })
    },
    handleAccountDetail(account_id){
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: account_id,
        },
      })
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    handlerFilter(name, option) {
      if (name == 'tags') {
        this.referralRequestStts = 1
        this.uploadRequestStts = 1
        this.tier_base = 1
        this.referral_coupon = 1
        this.referral_discount = 1
        this.is_flagged = 1
        this.is_blocked = 1
      } else {
        const data = this[option].reduce((result, item) => {
          result.push(item.id)
          return result
        }, [])
        this[name] = data
      }
      this.filterData()
    },
    handlerClearFilter(name) {
      this[name] = []
      if (name == 'tags') {
        this.referralRequestStts = 0
        this.uploadRequestStts = 0
        this.tier_base = 0
        this.referral_coupon = 0
        this.referral_discount = 0
        this.is_flagged = 0
        this.is_blocked = 0
      }
      this.filterData()
    },
    rowClick(row) {
      if (this.isDialog) {
        const {index} = row
        this.tableData.map(item => {
          item.checked = false
        })
        this.tableData[index].checked = true
        this.selectRow = index
        this.$emit('customerData', row)
      } else {
        let params = {
          type: this.type,
          search: this.search,
          status: this.status,
          referral_request_stts: this.referralRequestStts,
          upload_request_stts: this.uploadRequestStts,
          pageConfig: this.pageConfig,
          is_flagged: this.is_flagged
        }
        this.setFilterData({account: params})
        this.handleAccountDetail(row.id)
      }
    },
    rowClickFn(row) {
      if (this.isDialog) {
        const {index} = row
        this.tableData.map(item => {
          item.checked = false
        })
        this.tableData[index].checked = true
        this.selectRow = index
        this.$emit('customerData', row)
      } else{
        return ({
          path: '/accounts/detail',
          query: {
            customer_id: row.id,
          },
        })
      }
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getCustomerList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCustomerList()
    },
    network() {
      return {
        getCustomerList: async () => {
          let params = {}
          let {id_no = '', email = '', mobile_no = '', cust_typ = null, id_type = null, isrd_title = '', isrd_lst_nm = '', isrd_fst_nm = '', isrd_dob = '', isrd_com_nm = '', phone_no = '', bsns_nature_id = '', bsns_nature_other = ''} = this.formData
          if (this.isDialog && !this.isShare) {
            params.id_no = id_no
            params.mobile_no = mobile_no
            params.cust_typ = cust_typ
            params.email = email
            params.is_choose_guest = 1
            params.id_type = id_type
            params.isrd_title = isrd_title
            params.isrd_lst_nm = isrd_lst_nm
            params.isrd_fst_nm = isrd_fst_nm
            params.isrd_dob = isrd_dob
            params.isrd_com_nm = isrd_com_nm
            params.phone_no = phone_no
            params.bsns_nature_id = bsns_nature_id
            params.bsns_nature_other = bsns_nature_other
          }
          let {data} = await getCustomerList({
            type: this.type,
            search: this.search,
            page: this.pageConfig.currentPage,
            status: this.status,
            referral_request_stts: this.referralRequestStts,
            upload_request_stts: this.uploadRequestStts,
            order_id: this.orderId,
            tier_base: this.tier_base,
            referral_coupon: this.referral_coupon,
            referral_discount: this.referral_discount,
            is_blocked: this.is_blocked,
            verify_type: this.verify_type,
            ...params,
            created_start: this.date[0],
            created_end: this.date[1],
            source: this.source,
            referrer_code: this.referrer_code,
            partner_id: this.partner_id,
            is_flagged : this.is_flagged,
            user_agreement_1:this.user_agreement_1,
            vip_level:this.vip_level,
          })
          data.data.map((item, index) => {
            item.checked = false
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          // this.pageConfig.pageSize = data.per_page
        },
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;

  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
    .create-account{
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
    }
  }

  h1 {
    margin-bottom: 20px;
    font-size: 34px;
  }
  .verified-color{
    color: #22863a;
  }
  .pending_verify-color{
    color: #dbab09;
  }
  .span-status {
    display: block;
    margin-right: 5px;
    padding: 0 10px;
    height:  20px;
    line-height: 20px;
    border-radius: 25px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    &.success {
      color: #22863A;
      background: #DCFFE4;
    }
    &.warning {
      background: #FFF5B1;
      color: #B08800;
    }
    &.error {
      background: #D73A49;
      color: white;
    }
    &.warning-plain {
      padding: 0 8px;
      font-size: 12px;
      color: #735C0F;
      background: #FFFFFF;
      border: 1px solid #B08800;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
    }
    &.unread-uplod {
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border: 1px solid #F66A0A;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      color: #C24E00;
    }
    &.diamond-status, &.code-status, &.discount-status{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.verified{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #22863a;
      color: #22863a;
    }
    &.pending_verify{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #dbab09;
      color: #dbab09;
    }
    &.not_verify{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #d73a49;
      color: #d73a49;
    }
    &.blocked-status{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #CB2431;
      color: #D73A49;
    }

    &.type-status{
      border: 1px solid #6A737D;
      border-radius: 100px;
      color: #24292E;
      padding: 0 8px;
      text-align: center;
    }
  }
  .filter-top{
    margin-bottom: 30px;
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    padding: 16px;
    overflow: auto;
    //justify-content: space-between;
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .filter-left-container {
      display: flex;
      align-items: flex-start;
      .creation{
        width: 260px;
        min-width: 260px;
      }
      .status{
        flex: 1;
        display: flex;
        flex-direction: column;
        .row{
          display: flex;
        }
      }
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }

    .filter-checkbox {
      margin: 0 20px;
    }

    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
       /deep/ .el-checkbox__label {
         margin-left: 10px;
            padding: 0 10px;
            font-size: 12px;

              color: #735C0F;
              background: #FFFFFF;
              border: 1px solid #B08800;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
          }
      }


    }

    .type-button {
      // margin-right: 20px;
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              color: #24292E;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 18px;
              background: #FFFFFF;
              border: 1px solid #6A737D;
              border-radius: 100px;
            }
          }
        }
      }
    }
    .status-verify{
      /deep/.el-checkbox-group {
        .el-checkbox {
          display: flex;
          align-items: center;
          &:first-child {
            .el-checkbox__label {
              padding: 0 10px;
              margin-left: 10px;
              font-size: 12px;
              background: #FFFFFF;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
              border: 1px solid #d73a49;
              color: #d73a49;
            }
          }
          &:nth-child(2) {
            .el-checkbox__label {
              padding: 0 10px;
              margin-left: 10px;
              font-size: 12px;
              background: #FFFFFF;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
              border: 1px solid #dbab09;
              color: #dbab09;
            }
          }
          &:nth-child(3) {
            .el-checkbox__label {
              padding: 0 10px;
              margin-left: 10px;
              font-size: 12px;
              background: #FFFFFF;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
              border: 1px solid #22863a;
              color: #22863a;
            }
          }
        }
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: nowrap;
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    td{
      vertical-align: top;
      padding: 10px 0 !important;
    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */

      color: #24292E;
    }
  }
  .flex-aglin{
    align-items: center;
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
    .login-text{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
    .tags{
      margin-top: 2px;
    }
  }
  ::v-deep .el-checkbox-group{
    .el-checkbox__label span{
      line-height: 20px !important;
    }
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .green_tip{
    color: rgb(67, 181, 92);
  }
  .block{
    display: block;
  }
  .color-purple{
    color: #6F42C1!important;
  }
}
.showLick{
  color:  #000;
  text-decoration: none;
  font-weight: 600;
  &:hover{
    color:  #0366D6;
  }
  &.cname{
    word-break: break-word;
    white-space: normal;
  }
}
.unname{
  font-style: italic;
  color: #6A737D;
}
.pointer{
  cursor: pointer;
}
.flex-column{
  display: flex;
  flex-direction: column;
   .row{
    display: flex;
    & + .row{
      margin-top: 15px;
    }
    .tag-status{
      width: 165px;
    }
  }
}
.time-text{
  font-size: 12px;
  display: flex;
  flex-direction: column;
}
.orange{
  color: #E36209;
}
.filter-card {
  margin-bottom: 15px;
  background: white;
  border: 1px solid #E1E4E8;
  border-radius: 6px;
  //border-top: none;
  .filter-main {
    display: flex;
    padding: 0 15px;
    overflow-x: auto;
    .form-item{
      white-space: nowrap;
      /deep/.el-checkbox__label{
        white-space: nowrap;
      }
    }
    .all {
      display: inline-block;
      padding-left: 15px;
      color: #409eff;
      cursor: pointer;
    }
    .filter-left, .filter-middler, .filter-right, .filter-last {
      padding: 15px 0;
    }
    .filter-left {
      padding-right: 10px;
      width: 290px;
      flex: 1;

    }
    .left-border{
      border-left: 1px solid #E1E4E8;
    }
    .filter-middler {
      padding: 15px 10px;
      border-left: 1px solid #E1E4E8;
      border-right: 1px solid #E1E4E8;
      flex: 2;
    }
    .filter-right {
      padding: 15px 10px;
      border-right: 1px solid #E1E4E8;
      flex: 1;
    }
    .filter-last{
      padding-left: 10px;
      flex: 1;
    }
  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }

    &.red {
      background: #D73A49;
    }
  }
  .status-button {
    // margin-right: 20px;
    ::v-deep .el-checkbox-group {
      .el-checkbox {
        .el-checkbox__label {
          span {
            display: inline-block;
            padding: 0px 10px;
            height: auto;
            //line-height: 30px;
            font-size: 12px;
            border: 0;
            border-radius: 100px;
          }
        }
        &:nth-child(3) {
          .el-checkbox__label {
            span {
              background: #D73A49;
              color: white;
            }
          }
        }
        // &:last-child {
        //    .el-checkbox__label{
        //     span{
        //       border:1px solid #B08800;
        //       color: #B08800;
        //       background: white;
        //     }
        //   }
        // }
        &:first-child {
          .el-checkbox__label {
            span {
              background: #DCFFE4;
              color: #22863A;
            }
          }
        }
        &:nth-child(2) {
          .el-checkbox__label {
            span {
              background: #FFF5B1;
              color: #B08800;
            }
          }
        }
      }
    }
  }
  .upload-status{
    margin-bottom: 5px;
  }
  .upload-status {
    display: flex;
    align-items: center;
    margin-right: 15px;
    // padding: 0 10px;
    /deep/ .el-checkbox__label {
      margin-left: 10px;
      padding: 0 10px;
      font-size: 12px;
      background: #FFFFFF;
      border: 1px solid #F66A0A;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      color: #C24E00;
    }
  }

  .diamond-status, .code-status, .discount-status{
    display: flex;
    align-items: center;
    //margin-right: 5px;
    //padding: 0 10px;
    margin-bottom: 5px;
    /deep/ .el-checkbox__label {
      margin-left: 10px;
      padding: 0 10px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #0366D6;
      color: #0366D6;
    }
  }
  .blocked-status{
    display: flex;
    align-items: center;
    //margin-right: 5px;
    //padding: 0 10px;
    /deep/ .el-checkbox__label {
      margin-left: 10px;
      padding: 0 10px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #CB2431;
      color: #D73A49;
    }
  }
  .status-verify{
    /deep/.el-checkbox-group {
      .el-checkbox {
        display: flex;
        align-items: center;
        &:first-child {
          .el-checkbox__label {
            padding: 0 10px;
            margin-left: 10px;
            font-size: 12px;
            background: #FFFFFF;
            border-radius: 100px;
            line-height: 20px;
            white-space: nowrap;
            border: 1px solid #d73a49;
            color: #d73a49;
          }
        }
        &:nth-child(2) {
          .el-checkbox__label {
            padding: 0 10px;
            margin-left: 10px;
            font-size: 12px;
            background: #FFFFFF;
            border-radius: 100px;
            line-height: 20px;
            white-space: nowrap;
            border: 1px solid #dbab09;
            color: #dbab09;
          }
        }
        &:nth-child(3) {
          .el-checkbox__label {
            padding: 0 10px;
            margin-left: 10px;
            font-size: 12px;
            background: #FFFFFF;
            border-radius: 100px;
            line-height: 20px;
            white-space: nowrap;
            border: 1px solid #22863a;
            color: #22863a;
          }
        }
      }
    }
  }
}
.text-italic{
  font-style: italic;
}
</style>
